import React from "react";
import { Box, AppBar, Toolbar, Typography, Link } from "@mui/material";

function Footer() {
  // دالة لإنشاء الروابط
  const renderLink = (text, href) => (
    <Typography variant="body2" sx={{ marginBottom: "8px" }}>
      <Link color="#fff" href={href} sx={{ textDecoration: "none" }}>
        {text}
      </Link>
    </Typography>
  );

  return (
    <div dir="rtl" style={{ marginTop: "2%" }}>
      <AppBar
        position="static"
        color="primary"
        sx={{ padding: "20px 0", textAlign: "center" }}
      >
        {/* القسم العلوي */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "8px",
            marginX: { xs: "5%", md: "10%" },
          }}
        >
          {/* روابط سياسة الخصوصية وشروط الاستخدام */}
          {renderLink("سياسة الخصوصية", "/privacypolicy")}
          {renderLink("شروط الاستخدام", "/termsofuse")}
        </Box>

        {/* الشريط السفلي */}
        <Toolbar
          sx={{
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#fff",
            }}
          >
            كوبون أول طلب
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default Footer;
